<app-header-one [class]="'header-gym'"></app-header-one>
<section class="pt-0 cashpay-page">
  <div class="container">
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-3">
        <h2 class="my-5 d-none d-md-block">Il tuo ordine</h2>
        <div class="mt-4 d-block d-md-none"><app-navigation-bar [page]="'Checkout'"></app-navigation-bar></div>
      </div>
      <div class="col-xl-9 col-lg-9 col-md-9 mt-5">
        <div class="row mt-5">
          <div class="col-12">
            <div class="checkout-page">
              <div class="checkout-title m-0">
                <h3>Pagamento con carta di credito</h3>
              </div>
              <div class="checkout-form py-3" *ngIf="cartData">
                <h2 class="pp-title text-start">
                  Attenzione!<br/> Transazione NON autorizzata!
                </h2>
                <div class="row my-5">
                  <div class="col-12 d-flex justify-content-between">
                    <button class="button-primary-text prev-btn" (click)="goToPay()">
                      <img src="assets/icons/freccia.svg">
                      Torna ai pagamenti
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="total-section py-4 px-3 d-block d-md-none" *ngIf="cartData">
  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_DOMICILIO || cartData.order.type_order == typeOrder.REST_DOMICILIO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>

  <div class="media mx-3 d-flex justify-content-between" *ngIf="cartData.order.type_order == typeOrder.REST_ASPORTO">
    <div class="media-body align-self-top">
      <p class="product-title m-0 total-title text-start">Totale</p>
    </div>

    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="!cartData.order.ismultiorder">
      {{cartData.order.euro_total.toFixed(2)}} &euro;
    </p>
    <p class="align-self-top m-0 text-end product-title total-title fw-bold" *ngIf="cartData.order.ismultiorder">
      {{cartData.order.eurocarttotal.toFixed(2)}} &euro;
    </p>
  </div>
</section>
<!-- 
<div class="mobile-fix-option	d-block d-sm-none mobile-footer-fixed">
  <button class="btn btn-solid btn-block btn-bg-light mx-auto text-center ng-star-inserted text-center"
     (click)="goToPay()">Torna ai pagamenti</button>
</div> -->
<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>